import { render, staticRenderFns } from "./LibraryFormatTemplate.vue?vue&type=template&id=5aad79aa&scoped=true&"
import script from "./LibraryFormatTemplate.vue?vue&type=script&lang=js&"
export * from "./LibraryFormatTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LibraryFormatTemplate.vue?vue&type=style&index=0&id=5aad79aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad79aa",
  null
  
)

export default component.exports